import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import store from './redux/store';
import App from './App';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.ENVIRONMENT,
});


render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
